<template>
  <div class="profit-loss-drill-through-main">
    <div class="drill-through-body">
      <TableBox v-if="showTableBox" :title="tableTitle" :tableData="tableData" :hideColumns="hideTableColumn" />
    </div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  components: {
  },
  data: function() {
    return {
      tableData: [],
      tableTitle: '',
      hideTableColumn: [],
      payload: {},
      showTableBox: false,
    }
  },
  props: {
    drillThroughDetails: { type: Array, default: function() { return [] } },
  },
  methods: {
    
  },
  async mounted() {
    var details = JSON.parse(sessionStorage.getItem(this.$route.params.drillThroughName));
    this.payload = details.data;
    this.showTableBox = true;

    let drillThroughType = this.$route.params.drillThroughName.split('-')[1].trim().split(' ')[0].trim();
    let drillThroughSeries = details.series;

    this.$fullscreenLoading('Getting Data');
    if (drillThroughType == 'DETAILS_MONTH') {
      this.tableTitle = `${drillThroughSeries} - Summary by GL Account`;
      this.payload['rotatetable'] = '1';
      this.payload['comparemonth'] = '1'; //fix to compare month due to column needs to group by month and the row is the gl accounts //for details_month only
      this.hideTableColumn = ['#','PNLSeq'];
      this.tableData = await this.$apiCallV2('/FINGLReport/GetProfitAndLossReport', this.payload); //use this api due to the payload for this report due to this API changes the column name for the date to description
    } else {
      this.tableTitle = `${drillThroughSeries} - Details by Transaction`;
      this.hideTableColumn = [];
      this.tableData = await this.$apiCallV2('/GLMaster/GetPNLAnalysis', this.payload); //for transaction just use the normal PnL API
    }
    this.$fullscreenLoading();
  },
  watch: {
  }
}
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.profit-loss-drill-through-main {
  font-size: 12px;
  padding: 5px 45px;

  > .drill-through-body {
    background-color: white;
    height: 100%;
    width: 100%;
    border-radius: 5px;
    padding: 5px;
  }
}
</style>